import React, { useState, useEffect } from 'react';
import Badge from '@material-ui/core/Badge';
import LanguageIcon from '@material-ui/icons/Language';
import MenuItem from '@material-ui/core/MenuItem';
import { makeStyles, Theme, createStyles, IconButton, Popover, withStyles } from '@material-ui/core';
import i18n from "i18next";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    typography: {
      padding: theme.spacing(2),
    },
    languageIcon: {
      marginRight: '5px',
      color: 'lightgray',
      fontSize: '30px'
    }
  }),
);

const StyledBadge = withStyles((theme: Theme) =>
  createStyles({
    badge: {
      right: 5,
      top: 3,
      border: `2px solid ${theme.palette.background.paper}`,
      padding: '0 4px',
    },
  }),
)(Badge);

export default (() => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  const [selectedLanguage, setSelectedLanguage] = useState<string>('');

  useEffect(() => {
    const storedLanguage = localStorage.getItem('lensOrderLanguage');
    if (storedLanguage) {
      setSelectedLanguage(storedLanguage);
    }
  }, []);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = async (selectLanguage: string) => {
    setAnchorEl(null);
    if (selectLanguage !== selectedLanguage) {
      setSelectedLanguage(selectLanguage);
      i18n.changeLanguage(selectLanguage);
      localStorage.setItem('lensOrderLanguage', selectLanguage);
    }
  };

  return (
    <>
      <IconButton aria-label="changeLanguage" onClick={handleClick}>
        <StyledBadge color="secondary">
          <LanguageIcon className={classes.languageIcon} />
        </StyledBadge>
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={() => handleClose(selectedLanguage)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem
          style={{ height: 30 }}
          key="ja"
          selected={selectedLanguage === 'ja'}
          onClick={() => handleClose('ja')}
        >
          日本語
        </MenuItem>
        <MenuItem
          style={{ height: 30 }}
          key="en"
          selected={selectedLanguage === 'en'}
          onClick={() => handleClose('en')}
        >
          English
        </MenuItem>
      </Popover>
    </>
  );
}) as React.FC;